import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import * as moment from 'moment';
import { Moment } from 'moment';
import { CommonService } from 'src/app/services/common.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'custom-date-picker',
  templateUrl: './custom-date-picker.component.html',
  styleUrls: ['./custom-date-picker.component.scss']
})
export class CustomDatePickerComponent implements OnInit {
  @Input() label: string;
  @Input() id: string;
  @Input() disabled: boolean;
  @Input() model;
  @Input() margin: string;
  @Input() format: string;
  @Input() errorMessage;
  @Input() placeholder;
  @Input() required: boolean = false;
  @Output() valueChange = new EventEmitter<any>();
  @Output() blur = new EventEmitter<any>();
  dateformats: any = environment.DATE_FORMAT.toLowerCase();
  constructor(public datepipe: DatePipe,private commonService: CommonService,) { }

  ngOnInit(): void {
    //onInit
    let data = this.model?.match(
      /^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/
    )
      ? true
      : false;
    if (!data) {
      this.model = this.momentFormatDate(this.model);
   }
  }

  onChange(event) {
    //onChange
  }


  onChangeDate(event) {
    let date: any;
    let data = event.value.match(
      /^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/
    )
      ? true
      : false;
    if (data) {
      let modifyDate = this.momentFormatDate(event.date);
      if (modifyDate) {
        this.valueChange.emit(modifyDate);
        this.model = modifyDate;
      }
    } else {
      if (event.value == '') {
        this.valueChange.emit('');
      } else {
        this.valueChange.emit(event.value);
      }
      this.model = event.value;
    }
  }

  momentFormatDate(date: Moment, localFormat?: string): string {
    if (date) {
      if (localFormat) {
        return moment(date).format(localFormat);
      } else {
        return moment(date).format(environment.DATE_FORMAT);
      }
      //return this.commonService.formetdateGetingfromAPI(date)
    }
    return '';
  }

  numbersValidation(data) {
    if (/^[0-9]+$/.test(data)) {
      const dateFormat =
        data.substring(0, 2) +
        '/' +
        data.substring(2, 4) +
        '/' +
        data.substring(4, data.length);
      return dateFormat;
    }
    if (/^[0-9*-]+$/.test(data)) {
      const dateFormat = data.split('-');
      return dateFormat[2] + '/' + dateFormat[1] + '/' + dateFormat[0];
    } else {
      return data;
    }
  }

  onBlur(event) {
    this.blur.emit(event.value);
  }

}
